/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'legal': {
    width: 32,
    height: 34,
    viewBox: '0 0 32 34',
    data: '<path pid="0" d="M26.5 16.7H5.8c-.5 0-1-.4-1-1 0-.5.4-1 1-1h20.7c.5 0 1 .4 1 1 0 .5-.4 1-1 1zM16 20.5H5.5c-.5 0-1 .4-1 1 0 .5.4 1 1 1H16c.5 0 1-.4 1-1s-.4-1-1-1zm0 5.8H5.5c-.5 0-1 .4-1 1 0 .5.4 1 1 1H16c.5 0 1-.4 1-1 0-.5-.4-1-1-1zM10.4 5.5c0-3 2.5-5.5 5.6-5.5 3.1 0 5.6 2.5 5.6 5.5S19.1 11 16 11c-3.1 0-5.6-2.5-5.6-5.5zm2 0C12.4 7.4 14 9 16 9s3.6-1.6 3.6-3.5C19.6 3.5 18 2 16 2s-3.6 1.5-3.6 3.5zm17.4 1.1h-4.6c-.5 0-1 .4-1 1s.4 1 1 1h4.6v18c0 .3-.1.5-.4.7L23.1 32H22v-9c0-.3.2-.5.5-.5h4.6c.5 0 1-.4 1-1 0-.5-.4-1-1-1h-6.2c-.4 0-.8.4-.8.8L20 32H2.2V8.6h4.6c.5 0 1-.4 1-1s-.4-1-1-1H2.2c-1.1 0-2 .9-2 2V32c0 1.1.9 2 2 2h21.5l7.5-5.5c.4-.3.6-.7.6-1.2V8.6c0-1.1-.9-2-2-2z"/>'
  }
})
